import React from 'react';
import { Worker } from '../types';

interface WorkersTabProps {
  workers: Worker[];
  onCreateWorker: () => void;
  onEditWorker: (worker: Worker) => void;
  onDeleteWorker: (worker: Worker) => void;
  onViewWorkerPortal: (workerId: string) => void;
}

export const WorkersTab: React.FC<WorkersTabProps> = ({
  workers,
  onCreateWorker,
  onEditWorker,
  onDeleteWorker,
  onViewWorkerPortal
}) => {
  return (
    <div style={{
      background: 'white',
      borderRadius: '0 0 15px 15px',
      padding: '2rem',
      boxShadow: '0 5px 15px rgba(0,0,0,0.1)',
      minHeight: '500px'
    }}>
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '2rem'
      }}>
        <h2 style={{ color: '#228B22', margin: 0 }}>Worker Management</h2>
        <button
          onClick={onCreateWorker}
          style={{
            padding: '0.75rem 1.5rem',
            background: '#228B22',
            color: 'white',
            border: 'none',
            borderRadius: '8px',
            cursor: 'pointer',
            fontSize: '1rem',
            fontWeight: '600'
          }}
        >
          + Add New Worker
        </button>
      </div>

      {workers.length === 0 ? (
        <div style={{
          textAlign: 'center',
          padding: '3rem',
          color: '#666'
        }}>
          <p>No workers found. Add your first worker to get started.</p>
        </div>
      ) : (
        <div style={{ display: 'grid', gap: '1rem' }}>
          {workers.map(worker => (
            <div
              key={worker._id}
              style={{
                background: '#f8f9fa',
                border: '1px solid #e9ecef',
                borderRadius: '12px',
                padding: '1.5rem',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center'
              }}
            >
              <div style={{ flex: 1 }}>
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '1rem',
                  marginBottom: '0.5rem'
                }}>
                  <h4 style={{
                    margin: 0,
                    color: '#228B22',
                    fontSize: '1.2rem'
                  }}>
                    {worker.name}
                  </h4>
                  <span style={{
                    background: worker.status === 'active' ? '#d1e7dd' : '#f8d7da',
                    color: worker.status === 'active' ? '#0a3622' : '#721c24',
                    padding: '0.25rem 0.75rem',
                    borderRadius: '20px',
                    fontSize: '0.8rem',
                    fontWeight: '600'
                  }}>
                    {worker.status}
                  </span>
                  {worker.isAvailable && (
                    <span style={{
                      background: '#d1ecf1',
                      color: '#0c5460',
                      padding: '0.25rem 0.75rem',
                      borderRadius: '20px',
                      fontSize: '0.8rem'
                    }}>
                      Available
                    </span>
                  )}
                </div>

                <div style={{
                  display: 'grid',
                  gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
                  gap: '1rem',
                  color: '#666',
                  fontSize: '0.9rem'
                }}>
                  <div>📧 {worker.email}</div>
                  <div>📍 {worker.region}</div>
                  <div>📋 {worker.currentWorkload || 0}/{worker.maxActiveOrders || 5} orders</div>
                  <div>📅 Joined: {new Date(worker.createdAt).toLocaleDateString()}</div>
                </div>
              </div>

              <div style={{ display: 'flex', gap: '0.5rem' }}>
                <button
                  onClick={() => onEditWorker(worker)}
                  style={{
                    padding: '0.5rem 1rem',
                    background: '#0d6efd',
                    color: 'white',
                    border: 'none',
                    borderRadius: '6px',
                    cursor: 'pointer',
                    fontSize: '0.9rem'
                  }}
                >
                  Edit
                </button>
                <button
                  onClick={() => onDeleteWorker(worker)}
                  style={{
                    padding: '0.5rem 1rem',
                    background: '#dc3545',
                    color: 'white',
                    border: 'none',
                    borderRadius: '6px',
                    cursor: 'pointer',
                    fontSize: '0.9rem'
                  }}
                >
                  Delete
                </button>
                <button
                  onClick={() => onViewWorkerPortal(worker._id)}
                  style={{
                    padding: '0.5rem 1rem',
                    background: '#228B22',
                    color: 'white',
                    border: 'none',
                    borderRadius: '6px',
                    cursor: 'pointer',
                    fontSize: '0.9rem'
                  }}
                >
                  👨‍🌾 Worker View
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
